import {announce} from '@github-ui/aria-live'
import {noop} from '@github-ui/noop'
import {createContext, type PropsWithChildren, use, useMemo} from 'react'

import {useListItemTitle} from './TitleContext'

export type SelectionContextProps = {
  isSelected: boolean
  onSelect: (isSelected: boolean) => void
}

const SelectionContext = createContext<SelectionContextProps>({isSelected: false, onSelect: noop})

type SelectionProviderProps = PropsWithChildren & {value: SelectionContextProps}

export const SelectionProvider = ({children, value: {isSelected, onSelect}}: SelectionProviderProps) => {
  const {title} = useListItemTitle()

  const contextProps = useMemo(() => {
    const onSelectAndAnnounce = (selected: boolean) => {
      announce(selected ? `Selected. ${title}.` : `Unselected. ${title}.`)
      onSelect(selected)
    }
    return {isSelected, onSelect: onSelectAndAnnounce}
  }, [isSelected, onSelect, title])
  return <SelectionContext value={contextProps}>{children}</SelectionContext>
}
SelectionProvider.displayName = 'ListItemSelectionProvider'

export const useListItemSelection = () => {
  return use(SelectionContext)
}
